var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVerificationUploadIdQrcodePreview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 346,
    height: 345,
    viewBox: "0 0 346 345",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M123.519 76.4472L122.898 75.2328L217.083 24.6074L217.704 25.8218L123.519 76.4472Z",
    fill: "#DFE1E1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M244.287 96.4382V95.0582H276.441C282.03 95.0582 286.584 90.525 286.584 84.9291V33.1929C286.584 27.6039 282.03 23.0636 276.441 23.0636H224.691C219.102 23.0636 214.548 27.6039 214.548 33.1929V75.8349H213.168V33.1929C213.168 26.838 218.343 21.6836 224.691 21.6836H276.441C282.789 21.6836 287.964 26.838 287.964 33.1929V84.9291C287.964 91.284 282.789 96.4382 276.441 96.4382H244.287Z",
    fill: "#DFE1E1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M280.365 94.2825L280.917 95.5313L244.554 112.291L244.002 111.042L280.365 94.2825Z",
    fill: "#DFE1E1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M211.293 313.612C223.782 313.612 233.925 303.496 233.925 291.021V98.4284C233.925 85.9532 223.782 75.8309 211.293 75.8309H221.781C234.27 75.8309 244.344 85.9532 244.344 98.4284V291.021C244.344 303.496 234.27 313.612 221.781 313.612H211.293Z",
    fill: "#151515"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.0898 210.931H98.477V291.017C98.477 303.113 108.28 312.925 120.395 312.925H211.984C224.099 312.925 233.902 303.113 233.902 291.017V148.877H235.289V291.017C235.289 303.872 224.839 314.303 211.984 314.303H120.395C107.54 314.303 97.0898 303.872 97.0898 291.017V210.931ZM235.289 143.088H233.902V98.4302C233.902 86.3247 224.099 76.5221 211.984 76.5221H120.395C108.28 76.5221 98.477 86.3247 98.477 98.4302V202.996H97.0898V98.4302C97.0898 85.5664 107.54 75.1441 120.395 75.1349H211.984C224.839 75.1441 235.289 85.5664 235.289 98.4302V143.088Z",
    fill: "#151515"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M184.303 88.3326C184.303 86.2004 182.574 84.471 180.441 84.471C173.494 84.471 158.965 84.471 152.018 84.471C149.885 84.471 148.156 86.2004 148.156 88.3326C148.156 88.3333 148.156 88.3333 148.156 88.3341C148.156 90.4663 149.885 92.1957 152.018 92.1957C158.965 92.1957 173.494 92.1957 180.441 92.1957C182.574 92.1957 184.303 90.4663 184.303 88.3341C184.303 88.3333 184.303 88.3333 184.303 88.3326Z",
    fill: "#151515"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M230.485 31.7749V41.0642C230.485 41.4464 230.162 41.7533 229.785 41.7533H220.499C220.122 41.7533 219.799 41.4464 219.799 41.0642V31.7749C219.799 31.3927 220.122 31.0858 220.499 31.0858H229.785C230.162 31.0858 230.485 31.3927 230.485 31.7749ZM229.085 32.464H221.172V40.3751H229.085V32.464Z",
    fill: "#151515"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M281.028 31.7749V41.0642C281.028 41.4464 280.705 41.7533 280.328 41.7533H271.042C270.665 41.7533 270.342 41.4464 270.342 41.0642V31.7749C270.342 31.3927 270.665 31.0858 271.042 31.0858H280.328C280.705 31.0858 281.028 31.3927 281.028 31.7749ZM279.628 32.464H271.714V40.3751H279.628V32.464Z",
    fill: "#151515"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M257.569 40.6322V36.0207H262.202V40.6322H257.569ZM225.355 49.8626V45.2474H239.145V49.8626H248.375V36.0207H243.741V45.2474H239.145V40.6322H234.511V31.4053H252.972V40.6322H257.569V45.2474H252.972V49.8626H271.433V45.2474H280.664V49.8626H276.03V54.4779H280.664V59.0932H271.433V63.7084H266.799V72.9389H262.202V68.3236H257.569V54.4779H252.972V68.3236H257.569V72.9389H248.375V77.4948H252.972V86.7253H248.375V77.5541H234.511V68.3236H229.951V63.7084H234.585V68.3236H239.145V72.9389H243.741V68.3236H248.375V54.4779H243.741V59.0932H239.145V54.4779H234.585V59.0932H225.355V63.7084H220.758V49.8626H225.355ZM243.741 68.3236H239.145V63.7084H243.741V68.3236ZM234.511 54.4779V49.8626H229.951V54.4779H234.511ZM262.202 54.4779V59.0932H266.799V54.4779H262.202ZM266.799 72.9389H280.664V77.5541H271.433V82.11H266.799V86.7253H257.569V77.4948H266.799V72.9389ZM280.664 63.7084V68.3236H276.03V63.7084H280.664ZM228.098 33.4516V39.3829H222.166V33.4516H228.098ZM278.662 33.4516V39.3829H272.73V33.4516H278.662Z",
    fill: "#151515"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M167.635 296.189C175.021 296.189 181.008 290.202 181.008 282.817C181.008 275.431 175.021 269.445 167.635 269.445C160.25 269.445 154.264 275.431 154.264 282.817C154.264 290.202 160.25 296.189 167.635 296.189Z",
    fill: "#428DFC"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M160.578 283.599L161.493 282.566L166.195 286.773L173.678 277.401L174.754 278.264L166.815 288.202C166.695 288.354 166.526 288.442 166.336 288.461C166.146 288.473 165.956 288.41 165.815 288.284L160.578 283.599Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M227.158 129.531H104.955V130.911H227.158V129.531Z",
    fill: "#9E007E"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M227.158 245.423H104.955V246.803H227.158V245.423Z",
    fill: "#9E007E"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M201.804 313.609H221.595C234.08 313.609 244.16 303.491 244.16 291.016C244.16 269.422 244.16 240.717 244.16 205.751C244.16 167.197 244.16 122.224 244.16 98.4294C244.16 85.9447 234.08 75.8276 221.595 75.8276H196.441",
    stroke: "#151515",
    strokeWidth: 1.997,
    strokeMiterlimit: 1.5,
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M238.742 110.023H240.121V133.949H238.742V110.023Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerificationUploadIdQrcodePreview);
export default __webpack_public_path__ + "static/media/verification--uploadId__qrcodePreview.eba0168a6c625b95d147cdc5881b3b50.svg";
export { ForwardRef as ReactComponent };